import * as React from 'react';
import { useMemo } from 'react';

import PageNavigation from 'components/common/PageNavigation';
import { styleSuffix, contentSuffix, deliverySuffix, shareSuffix } from 'report/ReportRoutes';

const pageNavigation = (prefix: string, isCreating: boolean = false) => [
  { description: 'Overview', path: prefix, exactPathMatch: true },
  { description: 'Content', path: `${prefix}${contentSuffix}` },
  { description: 'Delivery', path: `${prefix}${deliverySuffix}` },
  { description: 'Style', path: `${prefix}${styleSuffix}` },
  ...(isCreating ? [{ description: 'Share', path: `${prefix}${shareSuffix}` }] : []),
];

type Props = {
  prefix: string;
  isCreating?: boolean;
};

const ReportCreationNavigation = ({ prefix, isCreating = false }: Props) => {
  const paths = useMemo(() => pageNavigation(prefix, isCreating), [prefix, isCreating]);

  return <PageNavigation items={paths} />;
};

export default ReportCreationNavigation;
